import { Event } from "../Event";

export class UserEvents extends Event {

  public onLoad = async () => {
    if (this.globalProps.isEdit) {
      this.setField("user_reset_password", { hidden: false })
    }


    if (!this.globalProps.isEdit) {
      this.setState("loadings", ["user_new_name", "user_new_cpf_cnpj", "user_new_password", "user_custom_email"])
      const { user_new_name: userName, user_new_password: userPassword, user_new_cpf_cnpj: userCpf, user_custom_email: userEmail } = this.values

      if (!userName) {
        this.setFieldValue("user_new_name", "‎")
      }

      if(!userEmail) {
        this.setFieldValue("user_custom_email", "‎")
      }

      if (!userPassword) {
        this.setFieldValue("user_new_password", "‎")
      }

      if (!userCpf) {
        this.setFieldValue("user_new_cpf_cnpj", "‎")
      }

      setTimeout(() => {
        this.setState("loadings", [])
      }, 200)
    }
  }
}